import { SxProps } from '@mui/system';
import { colorTokens } from '@rideiq/shared/components/variables';

export const StyledFormGroupSx: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  '.MuiFormControlLabel-label': { fontSize: 14, fontWeight: 400, color: colorTokens.text.dark },
};
